class VariantPicker {
  constructor(container) {
    this.container = container;
    this.formId = this.container.dataset.formId;
    this.selectsId = this.container.dataset.selectsId;
    this.popoverId = this.container.dataset.popoverId;
    this.selectId = this.container.dataset.selectId;
    this.values = JSON.parse(this.container.dataset.values);
    this.productId = this.container.dataset.productId;
    
    this.init();
  }

  init() {
    const form = document.getElementById(this.formId);
    const variantSelects = document.getElementById(this.selectsId);
    const popover = this.container.querySelector(`#${CSS.escape(this.popoverId)}`);
    const select = this.container.querySelector(`#${CSS.escape(this.selectId)}`);
    const selectButton = this.container.querySelector(`#${CSS.escape(this.selectId)}-button`);
    const selectLabel = this.container.querySelector(`#${CSS.escape(this.selectId)}-label`);

    if (!form) return;

    if (this.values) {
      this.values.forEach(value => {
        const optionButton = this.container.querySelector(`#${CSS.escape(this.formId)}-option-${CSS.escape(value)}`);
        if (optionButton) {
          optionButton.addEventListener('click', () => {
            select.value = value;
            selectLabel.innerHTML = optionButton.getElementsByClassName("label-main")[0].innerHTML;
            popover.classList.add("hidden");

            const buyButton = form.querySelector(".product-form__submit");
            if (buyButton) {
              buyButton.classList.add("button--primary");
              buyButton.classList.remove("button--secondary");
            }

            variantSelects.dispatchEvent(new Event('change'));
          });
        }
      });
    }

    selectButton.addEventListener('click', () => {
      if (popover.classList.contains("hidden")) {
        popover.classList.remove("hidden");
      } else {
        popover.classList.add("hidden");
      }
    });
  }
}

// Initialize all variant pickers when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form__input--dropdown').forEach(container => {
    new VariantPicker(container);
  });
});
